/**
 * 前台顯示關閉判斷（選人下拉用）。
 * 僅在 API／物件「明確關閉」時為 true；欄位缺失視為非關閉（防護，避免整份選單被濾空）。
 */
export function isFrontendVisibilityOff(employee) {
  if (!employee || typeof employee !== "object") return false;
  const value =
    employee.frontend_visibility !== undefined
      ? employee.frontend_visibility
      : employee.frontendVisibility;
  return value === false || value === 0 || value === "0";
}

/** 選人下拉是否可列為新選項（明確關閉前台顯示者除外） */
export function isFrontendVisibilitySelectable(employee) {
  return !isFrontendVisibilityOff(employee);
}

/** 從員工物件或 id 解析數字 id */
export function resolveStaffRecordId(record) {
  if (record == null || record === "") return null;
  if (typeof record === "number" || typeof record === "string") {
    const n = Number(record);
    return Number.isNaN(n) ? null : n;
  }
  const raw =
    record.id ??
    record.employeeId ??
    record.employee_id ??
    record.consultantId ??
    record.consultant_id ??
    record.contributorId ??
    record.value;
  if (raw == null || raw === "") return null;
  const n = Number(raw);
  return Number.isNaN(n) ? null : n;
}

/** 將目前已選 id（單一、陣列或巢狀陣列）整理為 Set */
export function normalizeKeepSelectedStaffIds(ids) {
  const set = new Set();
  const add = (value) => {
    const id = resolveStaffRecordId(value);
    if (id != null) set.add(id);
  };

  if (Array.isArray(ids)) {
    ids.forEach((item) => {
      if (Array.isArray(item)) item.forEach(add);
      else add(item);
    });
  } else if (ids != null && ids !== "") {
    add(ids);
  }

  return set;
}

/** 是否為編輯時需保留的目前已選 id */
export function isKeepSelectedStaffId(recordOrId, keepSelectedIds) {
  const keepSet =
    keepSelectedIds instanceof Set
      ? keepSelectedIds
      : normalizeKeepSelectedStaffIds(keepSelectedIds);
  if (!keepSet.size) return false;
  const id = resolveStaffRecordId(recordOrId);
  return id != null && keepSet.has(id);
}

/**
 * 選人下拉是否可顯示：新增時排除關閉前台顯示；編輯時保留目前已選。
 */
export function isStaffSelectableForDropdown(record, keepSelectedIds = null) {
  if (isKeepSelectedStaffId(record, keepSelectedIds)) return true;
  return isFrontendVisibilitySelectable(record);
}

/** 依前台顯示規則過濾選人清單（可保留目前已選 id） */
export function filterStaffForSelectDropdown(
  records = [],
  { keepSelectedIds, jobTitle, predicate } = {}
) {
  const keepSet =
    keepSelectedIds instanceof Set
      ? keepSelectedIds
      : normalizeKeepSelectedStaffIds(keepSelectedIds);

  return (Array.isArray(records) ? records : []).filter((record) => {
    if (jobTitle) {
      const title = record?.job_title ?? record?.jobTitle;
      if (title !== jobTitle) return false;
    }
    if (predicate && !predicate(record)) return false;
    if (keepSet.size && isKeepSelectedStaffId(record, keepSet)) return true;
    return isFrontendVisibilitySelectable(record);
  });
}
